import { Component, ChangeDetectionStrategy } from "@angular/core"
import { COMMON_IMPORTS } from "@app/common-imports"
import { Google2faQrCodeComponent } from "@app/google2fa-qr-code/google2fa-qr-code.component"
import { ModalWrapComponent } from "@app/modal-wrap/modal-wrap.component"
import { Modalable } from "@app/Modalable"
import { LangValPipe } from "@app/utils/lang-val.pipe"

@Component({
	selector: "app-walkthrough",
	imports: [
		COMMON_IMPORTS,
		LangValPipe,
		ModalWrapComponent,
		Google2faQrCodeComponent,
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: "./walkthrough.component.html",
})
export class WalkthroughComponent extends Modalable {
	modalProps: any = null
	nextTime: boolean = false
	step: number = 0

	async openUserDetails() {
		// await this.modalService.openMulti("cc-params-user-details")
	}

	btnClick() {
		//on clicking any side menu item, if mobile - closes the menu
		window.scroll(0, 0)
	}

	async openPatientsSmsSetting() {
		// return await this.modalService.openMulti("cc-params-sms")
	}

	async openAccountant() {
		// return await this.modalService.openMulti("cc-params-accountant")
	}

	async openPatientsAutomaticProforma() {
		// this.modalService.openMulti("gen-table-display", {
		// 	tableName: "patients_sms",
		// 	modalWidth: "modal-750",
		// })
	}
	async openCalendar() {
		// this.modalService.openMulti("calendar")
	}

	async openZones() {
		// this.modalService.openMulti("cc-params-zones")
	}
	async openItaSwitch() {
		// this.modalService.openMulti("cc-params-ita")
	}
	async openHeadtures() {
		// this.modalService.openMulti("gen-table-display", {
		// 	tableName: "headtures",
		// 	modalWidth: "modal-wide",
		// })
	}
	async openPayors() {
		// this.modalService.openMulti("gen-table-display", {
		// 	tableName: "payors",
		// 	modalWidth: "modal-wide",
		// })
	}
}
